<template>
  <div class="buscador-grupos__component-home__mobile">
    <div class="buscador-grupos__component-home__mobile__container">
      <div class="input-destino">
        <label>{{ $t('searcher.destiny.title') }}</label>
        <div class="selector-input">
          <template v-if="dataBuscadorGruposRealizado.lugarExperiencia">
            <span>{{ titleCase(dataBuscadorGruposRealizado.lugarExperiencia.nombre) }}</span>
          </template>
          <template v-else>
            <div data-bs-toggle="modal" data-bs-target="#modalBuscadorGruposDestinos" class="subtitulo-selector">
              {{ $t('searcher.destiny.subtitle') }}
              <i class="fa-solid fa-chevron-down" />
            </div>
          </template>
          <button
            v-if="dataBuscadorGruposRealizado.lugarExperiencia"
            class="btn btn-secondary p-0 px-2"
            @click="limpiarDestinoBuscador">
            <i class="fa-solid fa-x fa-sm" />
          </button>
        </div>
      </div>

      <div v-if="!isSkiandnight" class="input-fechas">
        <label>{{ $t('searcher.date.title') }}</label>
        <div class="selector-input">
          <template v-if="dataBuscadorGruposRealizado.date">
            {{ moment(dataBuscadorGruposRealizado.date).format('MMMM') }} -
            {{ dataBuscadorGruposRealizado.date.year }}
          </template>
          <template v-else>
            <div
              id="buttonModalBuscadorGruposFechas"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modalBuscadorGruposFechas"
              class="subtitulo-selector">
              {{ $t('searcher.date.subtitle') }}
              <i class="fa-solid fa-chevron-down" />
            </div>
          </template>
          <button
            v-if="dataBuscadorGruposRealizado.date"
            class="btn btn-secondary p-0 px-2"
            @click="limpiarFechaBuscador">
            <i class="fa-solid fa-x fa-sm" />
          </button>
        </div>
      </div>

      <div class="input-group d-flex flex-column align-items-center">
        <button class="btn btn-primary w-50" @click="doBusquedaGrupos">
          {{ $t('general.buscar') }}
        </button>
      </div>
    </div>
  </div>

  <div
    id="modalBuscadorGruposDestinos"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalBuscadorGruposDestinos"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="modalBuscadorGruposDestinosTitle" class="modal-title text-primary">
            {{ $t('searcher.destiny.title') }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div class="modal-body">
          <div class="column justify-content-around py-2">
            <div
              v-for="destino in dataFiltroViajes.destino"
              :key="destino.id"
              class="col-12"
              role="button">
              <div
                class="buscador-subtitulo text-clickable"
                data-bs-dismiss="modal"
                @click="sendDestinoBuscador(destino)">
                {{ titleCase(destino.nombre) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="!isSkiandnight"
    id="modalBuscadorGruposFechas"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalBuscadorGruposFechas"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="modalBuscadorGruposFechasTitle" class="modal-title text-primary">
            {{ $t('searcher.date.title') }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div class="modal-body d-flex justify-content-center">
          <Datepicker
            inline
            month-picker
            auto-apply
            :min-date="new Date(2022, 11, 1)"
            class="text-primary"
            @update:model-value="sendFechaBuscador" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { titleCase } from '@/helpers/filters';
  import Datepicker from '@vuepic/vue-datepicker';
  import moment from 'moment-timezone';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';

  const props = defineProps({
    informacionBusquedaGrupos: {
      type: Object,
      required: true,
    },
    filtroViajes: {
      type: Object,
      required: true,
    },
  });

  const error = ref(false);
  const isSkiandnight = checkDomain([DOMAINS.skiandnight]);

  const emits = defineEmits([
    'limpiarDestinoBuscador',
    'setearDestinoBuscador',
    'limpiarFechaBuscador',
    'setearFechaBuscador',
    'doBusquedaViajesGrupos',
  ]);

  const dataBuscadorGruposRealizado = computed(() => props.informacionBusquedaGrupos);
  const dataFiltroViajes = computed(() => props.filtroViajes);

  function limpiarDestinoBuscador() {
    emits('limpiarDestinoBuscador');
  }

  function limpiarFechaBuscador() {
    emits('limpiarFechaBuscador');
  }

  function sendDestinoBuscador(destino) {
    emits('setearDestinoBuscador', destino);
  }

  function sendFechaBuscador(fecha) {
    document.getElementById('buttonModalBuscadorGruposFechas').click();
    emits('setearFechaBuscador', fecha);
  }

  function doBusquedaGrupos() {
    error.value = false;
    emits('doBusquedaViajesGrupos');
  }
</script>

<style lang="scss" scoped>
  .text-clickable:hover {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
